import Common from '../../Common';

interface Options {
	limit?: number,
	limitFrom?: number,
	search?: string,
	orderBy?: string,
	orderDir?: string,
}

interface UserUsers {
	id: id
	alias: string
	name: string
	surname: string
	pbx_company_id: id
	company_name: string
}

const Users = class extends Common {
	browse = (userId: id, options?: Options): CustomResponseBrowse<{ users: UserUsers[] }> =>
		this.get(`/user/${userId}/users`, options)
}

export default Users;
